import {Dialog} from "evergreen-ui";
import React from "react";

export default function DeleteOFDialog({isShown, setIsShown, text, deleteAction, title}) {
    return (
        <Dialog
            isShown={isShown}
            title={title}
            intent="danger"
            onCloseComplete={() => setIsShown(false)}
            onConfirm={() => deleteAction()}
            confirmLabel="Удалить"
            cancelLabel="Отменить"
        >
            {text}
        </Dialog>
    )
}